export default __webpack_public_path__ + "static/media/iPhone 8 - 4.804f4ab2.png";